import React from 'react';
import { ReferenceArrayInput, AutocompleteArrayInput, SelectInput, FunctionField, ReferenceField, ReferenceInput, 
    AutocompleteInput, List, Datagrid, TextField, NumberInput, Edit, FormTab, TabbedForm, Toolbar, BooleanInput, 
    TextInput, ArrayInput, SimpleFormIterator, SaveButton, DateField } from 'react-admin';

const SettingsTitle = ({ record }) => {
    return <span>Settings Config {record ? `"${record.name}"` : ''}</span>;
};
export const SettingsList = (props) => (
    <List {...props} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Name" />
        </Datagrid>
    </List>
);
/**
 * 
 * @param {*} props 
 */
export const SettingsEdit = (props) => {
    return (<Edit title={<SettingsTitle />} mutationMode="pessimistic" {...props}>
        <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="Settings">
                <TextField source="name" label="Name" />
                <BooleanInput source="event_streaming_enabled" label="Enable Event Logs" />
                <BooleanInput source="gc_management_enabled" label="Enable GC Management" />
                <BooleanInput source="retargeting_enabled" label="Enable Retargeting of Direct Campaigns" />
                
                <BooleanInput source="insights_log_enabled" label="Insights Log Enabled" />
                
                <NumberInput source="adunit_limit" label="Ad Units Limit" />

                <NumberInput source="default_bid_price" label="Default Bid Price" />
                <NumberInput source="rtb_request_timeout_millis" label="RTB Request Timeout" />

                <TextInput source="log_level" label="Log Level" style={{ marginTop: "20px;" }} />

                <NumberInput source="imdb_reload_interval_minutes" label="IMDB reload interval (minute)" />

                <BooleanInput source="hourly_revenue_limit_enabled" label="Hourly Revenue Limit Feature Enabled" style={{whiteSpace: 'nowrap'}}/>
 
                <BooleanInput source="missing_site_logging_enabled" label="Log missing site/app Enabled" style={{whiteSpace: 'nowrap'}}/>

                <BooleanInput source="use_nobidviewability_only" label="Use NoBid viewability data only" style={{whiteSpace: 'nowrap'}}/>
                
                <ReferenceInput label="Publisher Request Log" helperText="Log incoming Bid Requests for this Publisher ID." 
                perPage={15}
                sort={{ field: 'name', order: 'ASC' }}
                filter={{ hidden: false }}
                filterToQuery={searchText => ({ search_name: searchText })}
                source="incoming_bidrequest_log_publisher"
                reference="publishers"
                basePath='publishers'
                allowEmpty emptyText="- None -"
                >
                <AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} optionValue="code" style={{ width: '200px' }} />
                </ReferenceInput>
                <ReferenceField reference="publishers" source="incoming_bidrequest_log_publisher" label="Selected Publisher Request Log">
                    <FunctionField label="Name" render={record => `${record.name} (${record.code})`}/>
                </ReferenceField>

                <ReferenceInput label="Default Direct Bidder"
					perPage={15}
					sort={{ field: 'name', order: 'ASC' }}
					filter={{ hidden: false }}
					filterToQuery={searchText => ({ search_name: searchText })}
					source="direct_bidder_id"
					reference="bidders"
					basePath='bidders'
					allowEmpty emptyText="- None -">
					<AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} optionValue="code" style={{ width: '200px' }} />
				</ReferenceInput>

                <ArrayInput source="video_mimes">
                    <SimpleFormIterator>
                        <TextField source="string" label="Default Video Mimes"></TextField>
                    </SimpleFormIterator>
                </ArrayInput>

            </FormTab>
            <FormTab label="Trackers">
                <TextInput fullWidth multiline source="revenue_event_for_banner" label="Revenue Tracker for Banner" />
                <TextInput fullWidth multiline source="revenue_event_for_video" label="Revenue Tracker for Video" />
                <TextInput fullWidth multiline source="revenue_event_for_native" label="Revenue Tracker for Native" />
                <TextInput fullWidth multiline source="click_event_for_native" label="Click Tracker for Native" />
                <TextInput fullWidth multiline source="tracking_events_for_video" label="Tracking Events for Video" />
            </FormTab>
            <FormTab label="Markups">
                <TextInput fullWidth multiline source="markup_config.DEFAULT_banner" label="Default Banner" />
                <TextInput fullWidth multiline source="markup_config.DEFAULT_video" label="Default Video" />
                <TextInput fullWidth multiline source="markup_config.NOBID_DFP_TAG_video" label="NoBid DFP Video" />
                <TextInput fullWidth multiline source="markup_config.NOBID_DFP_TAG_banner" label="NoBid DFP Banner" />
                <TextInput fullWidth multiline source="creative_nobid_renderTag" label="Tag Renderer for OpenRTB" />
            </FormTab>
            <FormTab label="Native Templates">
                <TextInput fullWidth multiline source="native_template.300x600" label="300x600" />
                <TextInput fullWidth multiline source="native_template.300x250" label="300x250" />
                <TextInput fullWidth multiline source="native_template.320x50" label="320x50" />
                <TextInput fullWidth multiline source="native_template.728x90" label="728x90" />
                <TextInput fullWidth multiline source="native_template.970x250" label="970x250" />
                <TextInput fullWidth multiline source="native_template.970x90" label="970x90" />
            </FormTab>
            <FormTab label="Combo">
                <h3>Rendered</h3>
                <TextInput multiline source="combo_configuration.renderer.markup" label="Renderer" style={{ width: "80%" }} />
                <hr style={{width: '100%'}}/>
                
                <h3 style={{width: '100%'}}>Desktop 300x600 (2 * 300x250) Template</h3>
                <TextInput fullwidth multiline source="combo_configuration.300x600.markup" label="300x600" style={{ width: "80%" }} />
                
                <h3 style={{width: '100%'}}>Desktop 970x250 (3 * 300x250) Template</h3>
                <TextInput fullwidth multiline source="combo_configuration.970x250.markup" label="970x250" style={{ width: "80%" }} />

                <h3 style={{width: '100%'}}>Mobile 300x250 (2 * 320x50) Template</h3>
                <TextInput fullwidth multiline source="combo_configuration.300x250.markup" label="300x250" style={{ width: "80%" }} />
                
            </FormTab>
            <FormTab label="Auction Optimizer">
                <h3>General</h3>
                <BooleanInput source="auction_optimizer_config.active" label="Active" style={{width: '260px'}}/>
                <BooleanInput source="auction_optimizer_config.adserver_active" label="Ad Server Active" style={{width: '260px'}}/>
                <SelectInput source="auction_optimizer_config.test_quota" 
                choices={[
                    { id: 0, name: '0% - No Test Quota / Always Block' },
                    { id: 1, name: '1% - Allow 1% for testing' },
                    { id: 2, name: '2% - Allow 2% for testing' },
                    { id: 3, name: '3% - Allow 3% for testing' },
                    { id: 4, name: '4% - Allow 4% for testing' },
                    { id: 5, name: '5% - Allow 5% for testing' },
                    { id: 10, name: '10%' },
                    { id: 15, name: '15%' },
                    { id: 20, name: '20%' },
                    { id: 25, name: '25%' },
                    { id: 30, name: '30%' },
                    { id: 35, name: '35%' },
                    { id: 40, name: '40%' },
                    { id: 45, name: '45%' },
                    { id: 50, name: '50%' },
                    { id: 55, name: '55%' },
                    { id: 60, name: '60%' },
                    { id: 65, name: '65%' },
                    { id: 70, name: '70%' },
                    { id: 75, name: '75%' },
                    { id: 80, name: '80%' },
                    { id: 85, name: '85%' },
                    { id: 90, name: '90%' },
                    { id: 95, name: '95%' },
                    { id: 99, name: '99%' },
                    { id: 100, name: '100% - Always Allow' },
                ]}
                label="Test Quota" 
                helperText="Quota of traffic for which we do NOT apply the optimization."
                defaultValue={5}
                style={{width: '260px'}}/>
                <NumberInput source="auction_optimizer_config.max_records" label="Maximum Records" defaultValue={50000}/>

                <h4 style={{float: 'left', paddingLeft: '0px'}}>Date Range (Start &gt; End)</h4>
                <NumberInput source="auction_optimizer_config.start_day_offset" label="Start Day Offset"
                helperText="How far back should the report start."
                style={{float: 'left', paddingLeft: '10px'}} />
                
                <NumberInput source="auction_optimizer_config.end_day_offset" label="End Day Offset"
                helperText="How far back should the report stop."
                style={{float: 'left', paddingLeft: '10px'}} />
                
                <br/><br/>

                <h3>Auction Optimization Rules</h3>
                <ArrayInput source="auction_optimizer_config.rules"  style={{width: '60%'}} label="---">
				  <SimpleFormIterator>
                    <h4>Bidders Filter</h4>
                    <ReferenceArrayInput 
                        source="bidders_include" 
                        reference="bidders"
                        basePath="bidders"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ bidder_type:'RTB', search_name: searchText })}
                        style={{float: 'left', paddingLeft: '10px'}} >
                        <AutocompleteArrayInput
                        label="Included Bidders" 
                        optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                        optionValue="code"
                        helperText="List of Bidders for which the Optimization is applied"
                        />
                    </ReferenceArrayInput>
                    <ReferenceArrayInput 
                        source="bidders_exclude" 
                        reference="bidders"
                        basePath="bidders"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ bidder_type:'RTB', search_name: searchText })}
                        >
                        <AutocompleteArrayInput
                        label="Excluded Bidders" 
                        optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                        optionValue="code"
                        helperText="List of Bidders for which the Optimization is NOT applied"
                        />
                    </ReferenceArrayInput>
                    
                    <h4>Publishers Filter</h4>
                    <ReferenceArrayInput 
                        source="publishers_include" 
                        reference="publishers"
                        basePath="publishers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        >
                        <AutocompleteArrayInput
                        label="Include Publishers" 
                        optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                        optionValue="code"
                        helperText="List of Publishers for which the Optimization is applied"
                        />
                    </ReferenceArrayInput>
                    <ReferenceArrayInput 
                        source="publishers_exclude" 
                        reference="publishers"
                        basePath="publishers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        >
                        <AutocompleteArrayInput
                        label="Excluded Publishers" 
                        optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                        optionValue="code"
                        helperText="List of Publishers for which the Optimization is NOT applied"
                        />
                    </ReferenceArrayInput>
                    
                    <h4>Sites Filter</h4>
                    <ReferenceArrayInput 
                        source="sites_include" 
                        reference="sites"
                        basePath="sites"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        >
                        <AutocompleteArrayInput
                        label="Include Sites" 
                        optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                        optionValue="code"
                        helperText="List of Sites for which the Optimization is applied"
                        />
                    </ReferenceArrayInput>
                    <ReferenceArrayInput 
                        source="sites_exclude" 
                        reference="sites"
                        basePath="sites"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        >
                        <AutocompleteArrayInput
                        label="Excluded Sites" 
                        optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                        optionValue="code"
                        helperText="List of Sites for which the Optimization is NOT applied"
                        />
                    </ReferenceArrayInput>
                    <br/>
                    <h4>Metrics</h4>
                    <NumberInput source="response_rate_minimum" label="Response Rate Minimum"
                    helperText="Block inventory where response rate is less or equal to the minimum"/>
                    <NumberInput source="fill_rate_minimum" label="Fill Rate Minimum"
                    helperText="Block inventory where fill rate is less or equal to the minimum"/>
                    <SelectInput source="per_unit_cost_metric" label="Metric to use to compare to unit cost"
                    helperText="Block inventory where chosen metric is less or equal to the bid request unit cost"
                    choices={[
                        {id: 'revenue_per_bid_request_pm', name: 'Gross Revenue Per Bid Request'},
                        {id: 'nb_revenue_per_bid_request_pm', name: 'NoBid Revenue Per Bid Request'},
                        {id: 'net_revenue_per_bid_request_pm', name: 'Publisher/Net Revenue Per Bid Request'}
                    ]}
                    allowEmpty
                    emptyText='- Do Not Apply - '
                    style={{width: '80%'}}
                    />
                  </SimpleFormIterator>
                </ArrayInput>
            </FormTab>

            <FormTab label="Auction OptimizerV2">
                <BooleanInput source="auction_optimizer_v2_config.active" label="Active" style={{width: '260px'}}/>
                <BooleanInput source="auction_optimizer_v2_config.adserver_active" label="Ad Server Active" style={{width: '260px'}}/>
                <SelectInput source="auction_optimizer_v2_config.test_quota" 
                choices={[
                    { id: 0, name: '0% - No Test Quota / Always Block' },
                    { id: 1, name: '1% - Allow 1% for testing' },
                    { id: 5, name: '5% - Allow 5% for testing' },
                    { id: 10, name: '10%' },
                    { id: 15, name: '15%' },
                    { id: 20, name: '20%' },
                    { id: 25, name: '25%' },
                    { id: 30, name: '30%' },
                    { id: 35, name: '35%' },
                    { id: 40, name: '40%' },
                    { id: 45, name: '45%' },
                    { id: 50, name: '50%' },
                    { id: 55, name: '55%' },
                    { id: 60, name: '60%' },
                    { id: 65, name: '65%' },
                    { id: 70, name: '70%' },
                    { id: 75, name: '75%' },
                    { id: 80, name: '80%' },
                    { id: 85, name: '85%' },
                    { id: 90, name: '90%' },
                    { id: 95, name: '95%' },
                    { id: 99, name: '99%' },
                    { id: 100, name: '100% - Always Allow' },
                ]}
                label="Test Quota" 
                helperText="Quota of traffic for which we do NOT apply the optimization."
                defaultValue={5}
                style={{width: '260px'}}/>
                <NumberInput source="auction_optimizer_v2_config.max_records" label="Maximum Records" defaultValue={50000}/>

                <br/><hr style={{width: '100%'}} /><br/>

                <h4>Date Range (Start &gt; End)</h4>
                <NumberInput source="auction_optimizer_v2_config.start_day_offset" label="Start Day Offset"
                helperText="How far back should the report start."
                />
                
                <NumberInput source="auction_optimizer_v2_config.end_day_offset" label="End Day Offset"
                helperText="How far back should the report stop." />

                <br/><hr style={{width: '100%'}} /><br/>

                <NumberInput source="auction_optimizer_v2_config.response_rate_minimum" label="Minimum Response Rate"
                    helperText="Block inventory where response rate is less or equal to the minimum" />

                <NumberInput source="auction_optimizer_v2_config.fill_rate_minimum" label="Minimum Fill Rate"
                    helperText="Block inventory where fill rate is less or equal to the minimum"/>

                <NumberInput source="auction_optimizer_v2_config.net_profit_minimum" label="Minimum Net Profit"
                    helperText="Block inventory where net profit is less or equal to the minimum"/>

                <br/><hr style={{width: '100%'}} /><br/>

                <h4>White listed Publishers</h4>
                <ReferenceArrayInput 
                    source="auction_optimizer_v2_config.white_listed_publishers"
                    reference="publishers"
                    basePath="publishers"
                    perPage={15} 
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    >
                    <AutocompleteArrayInput
                    label="Include Publishers"
                    optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                    optionValue="code"
                    helperText="List of Publishers for which the Optimization is NOT applied"
                    />
                </ReferenceArrayInput>

                <h4>White listed Bidders</h4>
                <ReferenceArrayInput 
                    source="auction_optimizer_v2_config.white_listed_bidders"
                    reference="bidders"
                    basePath="bidders"
                    perPage={15} 
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    >
                    <AutocompleteArrayInput
                    label="Include Bidders"
                    optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                    optionValue="code"
                    helperText="List of Bidders for which the Optimization is NOT applied"
                    />
                </ReferenceArrayInput>

                <h4>White listed Sites</h4>
                <ReferenceArrayInput 
                    source="auction_optimizer_v2_config.white_listed_sites"
                    reference="sites"
                    basePath="sites"
                    perPage={15} 
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    >
                    <AutocompleteArrayInput
                    label="Include Sites"
                    optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
                    optionValue="code"
                    helperText="List of Sites for which the Optimization is NOT applied"
                    />
                </ReferenceArrayInput>

                <h4>Bidder Configuration</h4>
                <ArrayInput source="auction_optimizer_v2_config.bidder_config">
                <SimpleFormIterator>
                    <ReferenceArrayInput label="Bidder"
                        perPage={15}
                        sort={{ field: 'name', order: 'ASC' }}
                        filter={{ hidden: false }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        source="bidders"
                        reference="bidders"
                        basePath='bidders'>
                        <AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} optionValue="code" style={{ width: '200px' }} />
                    </ReferenceArrayInput>
                    <NumberInput source="bidder_profit_factor" label="Bidder Profit Factor" helperText="1000000 * revenue * bidderProfitFactor / bidResponses" style={{width: '20%'}}/>
                    <NumberInput source="bidder_profit_per_million_minimum" label="Bidder Profit Minimum" helperText="Bidder Profit Factor > Bidder Profit Minimum" style={{width: '20%'}}/>
                </SimpleFormIterator>
                </ArrayInput>
                
            </FormTab>

            <FormTab label="Monitoring">
                <BooleanInput source="monitoring.enabled" label="Monitoring Enabled" />
                <NumberInput source="monitoring.min_threshold" label="Minimum Hourly Revenue Percentage Threshold" defaultValue="50"
                helperText="Hourly revenue should NOT drop below this percentage value."
                style={{width: '20%'}}/>
                <br/>
                <NumberInput source="monitoring.max_threshold" label="Maximum Hourly Percentage Threshold" defaultValue={90}
                helperText="Hourly revenue should NOT spike above this percentage value."
                style={{width: '20%'}}/>
                <br/>
                <NumberInput source="monitoring.min_threshold_daily" label="Minimum Daily Revenue Percentage Threshold" defaultValue="50"
                helperText="Daily revenue should NOT drop below this percentage value."
                style={{width: '20%'}}/>
                <br/>
                <NumberInput source="monitoring.max_threshold_daily" label="Maximum Daily Percentage Threshold" defaultValue={90}
                helperText="Daily revenue should NOT spike above this percentage value."
                style={{width: '20%'}}/>
                <br/>
                <TextInput source="monitoring.email" label="Destination Notification Emails (comma separated)" 
                style={{width: '30%'}}/>
                <br/>
                <TextInput source="monitoring.digest_email" label="Publisher Daily Digest Emails (comma separated)" 
                style={{width: '30%'}}/>
                <br/>
                <NumberInput source="monitoring.max_records" label="Maximum Top Publishers" defaultValue={50}
                helperText="Number of Publishers to select at the TOP."
                style={{width: '20%'}}/>
                <br/>
                <NumberInput source="monitoring.max_days" label="Maximum Days" defaultValue="30"
                helperText="Number of days to pull the report for Publishers."
                style={{width: '20%'}}/>
                <br/>

            </FormTab>
        </TabbedForm>

    </Edit>
    )
}
const CustomToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
